module.exports = __webpack_public_path__ + "cd68be34c657c0873946b0910e95d83b.png";